import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth, seed } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Hotel } from 'lucide-react';
import { toast } from 'sonner';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await seed();
    } catch (e) { /* ignore if seeded */ }
    try {
      const { data } = await auth.register(form);
      localStorage.setItem('easystay_token', data.token);
      localStorage.setItem('easystay_user', JSON.stringify(data.user));
      toast.success('Account created! Let\'s set up your hotel.');
      navigate('/register-hotel');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="lobby-theme min-h-screen flex items-center justify-center px-4" data-testid="register-page">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center mx-auto mb-3">
            <Hotel className="w-6 h-6 text-primary-foreground" />
          </div>
          <CardTitle className="heading-font text-xl">Register Your Hotel</CardTitle>
          <p className="text-sm text-muted-foreground mt-1">Start accepting bookings in minutes</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div><Label>Your Name</Label><Input value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} placeholder="John Smith" required data-testid="register-name" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} placeholder="you@hotel.com" required data-testid="register-email" /></div>
            <div><Label>Password</Label><Input type="password" value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))} placeholder="Min 6 characters" required data-testid="register-password" /></div>
            <Button type="submit" className="w-full h-11" disabled={loading} data-testid="register-submit">
              {loading ? 'Creating account...' : 'Create Account'}
            </Button>
          </form>
          <div className="text-center mt-4">
            <p className="text-sm text-muted-foreground">Already have an account? <Link to="/login" className="text-primary font-medium">Sign in</Link></p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
